// Conditional mediation is not required to use passkeys, but at this time we
// are only supporting passkeys if conditional mediation is available.
export const browserSupportsPasskeys = async () => {
  const PublicKeyCredential = window.PublicKeyCredential;
  if (PublicKeyCredential && typeof PublicKeyCredential.isConditionalMediationAvailable === 'function') {
    return PublicKeyCredential.isConditionalMediationAvailable();
  }
  return false;
};